import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import moment from 'moment';
import MindsetsJsSDK, {LoadingAction} from "mindsets-js-sdk";

import {DATE_FORMAT} from 'constants/index';
import analytic from 'utils/Analytic';
import {userCan} from 'utils/membership';
import FeatureLock from 'common/membership/FeatureLock';


function CreateQuiz(
    {
        code = undefined,
        beforeCreate = () => {
        },
        afterCreate = () => {
        },
        button_class = 'btn btn-on-dark'
    }
) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);

    function canCreate() {
        return !!me && userCan(me.subscription_status, 'download_project_extension');
    }

    function createQuiz(e) {
        if (e) {
            e.preventDefault();
        }

        if (!canCreate()) {
            window.open(process.env.PUBLIC_PRICING_URL, '_blank');
            return
        }

        beforeCreate();
        dispatch(LoadingAction(true, 'Creating Project Quiz'));
        MindsetsJsSDK().API.get(`project_quiz/${code}`, {}).then((response) => {
            const challenge_version = response.challenge_version;
            if (!challenge_version || !challenge_version.id) {
                throw ('No challenge version found.');
            }
            return MindsetsJsSDK().Api.lesson.create({
                challenge_version_id: challenge_version.id,
                name: moment().format(DATE_FORMAT) + ' Project Quiz'
            })
        }).then((response) => {
            afterCreate();
            dispatch(LoadingAction(false));
            // analytic.log('createClassCode', {
            //     name: challenge_version.name,
            //     code: challenge_version.challenge_code.code
            // }, response.lesson);
            navigate(`/teacher/class/${response.lesson.code}/setup`);
        }).catch((error) => {
            afterCreate();
            dispatch(LoadingAction(false));
            console.error(error);
        })
    }

    return (
        <FeatureLock
            enable={canCreate()}
            title={`Mindsets! Project Library`}
            feature_type={`project_extension`}
            onClickCallback={() => {}}
        >
            <button className={button_class} onClick={createQuiz}>
                <i className="fas fa-plus"/>
                <span>
                    {`Create Quiz`}
                </span>
            </button>
        </FeatureLock>
    );
}

CreateQuiz.propTypes = {
    code: PropTypes.string.isRequired,
    beforeCreate: PropTypes.func,
    afterCreate: PropTypes.func,
    button_class: PropTypes.string
};

export default CreateQuiz;
